import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Box
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {}
}));

export const TabPanel = ({
    label,
    value,
    index,
    p,
    children,
    ...props }) => {
    const classes = useStyles();

    return (
        <div
            className={clsx(classes.root, props.className)}
            role="tabpanel"
            hidden={value !== index}
            id={`settings-tabpanel-${index}`}
            aria-labelledby={`settings-tab-${index}`}
            {...props}>
            {value === index && (
                <Box p={p || p === 0 ? p : 3}>
                    {children}
                </Box>
            )}
        </div>
    );
}